import type { InferResponseType } from 'hono/client'
import { api } from '@/lib/api'

export const venueWorkspaceApi = api.api.workspaces[':slug']

export type VenuesResponse = InferResponseType<typeof venueWorkspaceApi.venues.$get, 200>
export type VenueDetailResponse = InferResponseType<
  (typeof venueWorkspaceApi.venues)[':venueId']['$get'],
  200
>
export type VenueListItem = VenuesResponse['venues'][number]
export type VenueDetail = VenueDetailResponse['venue']
export type PrepareUploadResponse = InferResponseType<
  (typeof venueWorkspaceApi.venues)[':venueId']['documents']['upload']['$post'],
  201
>
export type DownloadDocumentResponse = InferResponseType<
  (typeof venueWorkspaceApi.venues)[':venueId']['documents'][':documentId']['download']['$get'],
  200
>
